export default {
  REQUESTING: 'address/postalcode/REQUESTING',
  RESPONSE_ERROR: 'address/postalcode/RESPONSE_ERROR',
  FETCH_POSTALCODES: 'address/postalcode/FETCH',
  LIST_POSTALCODES: 'address/postalcode/LIST',
  SEARCH_POSTALCODE: 'address/postalcode/SEARCH',
  SEARCH_POSTALCODE_RECIEVED: 'address/postalcode/SEARCH_RECIEVED',
  FETCH_POSTALCODES2:'adress/postalCodes/FETCH_POSTALCODES2'
}
